import { memo } from "react";

const QualityIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-11 w-11" aria-hidden="true" focusable="false">
		<circle cx="12" cy="12" r="9" /><path d="m8 12 2.5 2.5L16.5 9" />
	</svg>
);

const OfferIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-11 w-11" aria-hidden="true" focusable="false">
		<path d="M8 5h8l2 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8l2-3Z" /><path d="M9 9h6M12 5V3M10 13h4" />
	</svg>
);

function Shapingd() {
	return (
		<section className="my-10 grid grid-cols-1 gap-2 overflow-x-hidden px-16 md:grid-cols-2 md:gap-10" aria-label="Azure benefits">
			<div className="text-center">
				<div className="my-4 flex items-center justify-center text-[#1f4c94]"><QualityIcon /></div>
				<h2 className="my-1 font-Jost-Medium text-2xl">Top Quality</h2>
				<p className="font-Jost-Regular text-gray-700">Wrap yourself in luxury with our commitment to premium-quality fabric.</p>
			</div>
			<div className="text-center">
				<div className="my-4 flex items-center justify-center text-[#1f4c94]"><OfferIcon /></div>
				<h2 className="my-1 font-Jost-Medium text-2xl">Best Offers</h2>
				<p className="font-Jost-Regular text-gray-700">Discover our best price offers today.</p>
			</div>
		</section>
	);
}

export default memo(Shapingd);
